<template>
  <div class="d-flex justify-content-center w-100">
    <loading-spinner/>
  </div>
</template>

<script>
import LoadingSpinner from '@src/components/misc/LoadingSpinner';
import { getCognitoUser, companyStartSession, companyEndSession, companySigninUrl } from '@src/lib/admin';

export default {
  props: {
    companyID: String,
  },
  components: {
    LoadingSpinner,
  },
  metaInfo: {
    title: 'Authenticating',
  },
  async mounted() {
    if ([ 'CompanyLogin', 'CompanyLogout', 'CompanySignin' ].includes(this.$route.name)) {
      this.trigger();
    }
  },
  methods: {
    async trigger() {
      try {
        const { name, path, params: { companyID } } = this.$route;
        if (!getCognitoUser()) {
          return this.$router.replace({ name: 'Login', query: { next: path } });
        }

        if (name === 'CompanyLogin') {
          const { query: { next } = {} } = this.$route;
          await companyStartSession(this, { companyID });

          if (typeof next === 'string' && next.endsWith('/playground')) {
            window.location.href = `/${companyID}/playground`;
          } else {
            this.$router.replace(next || { name: 'CompanyDashboard', params: { companyID } });
          }
        } else if (name === 'CompanyLogout') {
          const success = await companyEndSession(this, { companyID });
          if (success) {
            // If this was successful, redirect cleanly
            this.$router.replace({ name: 'Welcome' });
          } else {
            // Otherwise, redirect forcefully
            window.location = '/';
          }
        } else if (name === 'CompanySignin') {
          const redirect = companySigninUrl(this, { companyID });
          this.$assert(typeof redirect === 'string' && redirect.length, new Error('Missing redirect URL'));
          window.location = redirect;
        } else {
          window.location = '/';
        }
      } catch (err) {
        this.$log.error(err);
        this.$notifyFatalErr(err);
      }
    },
  },
  watch: {
    $route() {
      if ([ 'CompanyLogin', 'CompanyLogout', 'CompanySignin' ].includes(this.$route.name)) {
        this.trigger();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Admin/AuthCompany.vue